import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  UiButton,
  UiTextIconButton,
} from "../../_uiComponents/common/UiButton";
import VerificationProgressImage from "../../../styles/img/onboard/verify-progress.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { hideError } from "../../../_redux/_actions";
import { onboardingConstants } from "../../../_redux/_constants";
import {
  onboardingClearFormData,
  onboardingClearFormResponseData,
} from "../../../_redux/_actions/onboarding.actions";
import set from "../../../styles/img/onboard/all-set.png";

export const SuccessPage = (props) => {
  const { t, i18n } = useTranslation();
  const naviagate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(onboardingClearFormData());
    dispatch(onboardingClearFormResponseData());
    dispatch(hideError());
  }, []);

  const goToLogin = () => {
    dispatch(onboardingClearFormData());
    dispatch(onboardingClearFormResponseData());
    dispatch(hideError());
    naviagate("/");
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__body df-pw-tab">
            <Grid container className="df-align-center">
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }} className="df-pr-2">
                <img src={set} className="df-verify-progress-img" />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center"
              >
                <div className="df-onboard-radio df-onboard-nic-wr df-verify-progress">
                  <h4>{t("You are all set!")}</h4>
                  <p>
                    {t("Your online banking account is now ready to be used!")}
                  </p>

                  <div className="d-block df-verify-progress__acc-btn">
                    <UiButton
                      className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn"
                      name={t("Login to your LOLC Realtime Account")}
                      onClick={goToLogin}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
